import { render, staticRenderFns } from "./BtDashboardDesigner.vue?vue&type=template&id=64ee35fe&scoped=true&"
import script from "./BtDashboardDesigner.vue?vue&type=script&lang=js&"
export * from "./BtDashboardDesigner.vue?vue&type=script&lang=js&"
import style0 from "./BtDashboardDesigner.vue?vue&type=style&index=0&id=64ee35fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee35fe",
  null
  
)

export default component.exports